import { useEffect, useState, useContext } from "react";
import Acordion from "components/common/cart/Acordion";
import styles from "components/common/cart/cart.module.css";
import x1 from "assets/images/axnew1.png";
import panir from "assets/images/panir.jpg";
import gusht from "assets/images/gusht.png";
import { BiTrash } from "react-icons/bi";
import { BsPlus } from "react-icons/bs";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import ShoppingCart from "components/common/cart/ShoppingCart";
import CartItemsContext from "context/ShoppingCartItems";
import { addCommas } from "@persian-tools/persian-tools";
import Loader from "utils/Loader";
export default function LogInNumber({
  ChangeModalStar,
  item,
  setItems
  // shoppingData,
  // updateShoppingList,
  // prices,
  // setPrices,
  // setIsLoading,
}) {
  const {
    shoppingData,
    updateShoppingList,
    currentInventory,
    prices,
    setPrices,
    itemsCount,
    itemsId,
    supplierCount,
    shoppingDataBusiness,
    setShoppingDataBusiness,
    isLoading,
    setIsLoading
  } = useContext(CartItemsContext);

  const [disableButton, setDisableButton] = useState(true);
  const [datas, setDatas] = useState([]);
  const [limitId, setLimitId] = useState([]);
  const [send, setSend] = useState("");
  useEffect(() => {
    (() => {
      "use strict";

      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      const forms = document.querySelectorAll(".needs-validation");
      // Loop over them and prevent submission
      Array.prototype.slice.call(forms).forEach(form => {
        form.addEventListener(
          "submit",
          event => {
            if (!form.checkValidity()) {
              event.preventDefault();
              event.stopPropagation();
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    })();
  }, []);
  useEffect(() => {
    // prices.total == 0 ? setDisableButton(true) : setDisableButton(false)
    let temp = false;
    let ids = [];
    for (let i = 0; i < datas.length; i++) {
      if (
        datas[i].shopPrice <= datas[i].supplier.min_order_amount ||
        prices.total == 0
      ) {
        temp = true;
        datas[i].shopPrice <= datas[i].supplier.min_order_amount &&
          ids.push(datas[i].supplier.suppliers__id);
      }
    }
    setLimitId(ids);
    setDisableButton(temp);
  }, [prices, datas]);

  const auth = useContext(WithAuthentication);
  const add = () => {
    setPrices(prev => {
      return { ...prev, send: sumDeliveryPrice() };
      //       return { ...prev, send: supplierCount * 10000 };
      // send == "fast"
      //   ? setPrices((prev) => {
      //       return { ...prev, send: supplierCount * 10000 };
      //     })
      //   : setPrices((prev) => {
      //       return { ...prev, send: supplierCount * 8000 };
    });
    setDisableButton(false);
    if (auth.isLogged) {
      ChangeModalStar(2);
    } else {
      ChangeModalStar(1);
    }
  };
  const convertSecToMinOrH = sec => {
    let hours = Math.floor(sec / 3600);
    let min = (sec - hours * 3600) / 60;
    return (
      <>
        {hours > 0 && <>{hours}ساعت</>}
        {min > 0 && <>{min}دقیقه</>}
      </>
    );
  };
  const deliveryPrice = (price, discount) => {
    let mainPrice = price - discount;
    let showPrice = mainPrice > 0 ? <>{addCommas(mainPrice)}تومان</> : "رایگان";
    return showPrice;
  };

  const sumDeliveryPrice = () => {
    let sum = 0;
    for (let i = 0; i < datas.length; i++) {
      for (const k in datas[i].delivery) {
        if (datas[i].delivery[k].status == true) {
          sum += datas[i].delivery[k].price - datas[i].delivery[k].discount;
        }
      }
    }
    return sum;
  };

  const deliveryHandler = (index, type) => {
    let temp = [...datas];
    // console.log("8888", index, type);
    temp[index].delivery.fast = {
      ...datas[index].delivery.fast,
      status: !datas[index].delivery.fast.status
    };
    temp[index].delivery.normal = {
      ...datas[index].delivery.normal,
      status: !datas[index].delivery.normal.status
    };
    setDatas(temp);
  };
  const inputHandler = (names, value, index) => {
    let temp = [...datas];
    temp[index][names] = value;
    setDatas(temp);
  };

  useEffect(() => {
    setDatas(shoppingDataBusiness);
  }, [shoppingDataBusiness]);
  // let SendNumber = (e) => {
  //   e.preventDefault();
  //   ChangeModal(1);

  // };
  // console.log("suupid", supplierCount);
  // console.log("send", prices);
  // console.log("setdatas", datas);
  // console.log("sumDeliveryPrice", sumDeliveryPrice());
  console.log("shoppingDataBusiness", shoppingDataBusiness);

  return (
    <div
      className={`rounded mx-auto ${styles.LogInNumber}`}
      style={{ backgroundColor: "white" }}
    >
      {isLoading == true && <Loader />}
      <div className=" d-flex justify-content-between">
        <div className="d-flex w-100  flex-column align-items-center justify-content-evenly ">
          {/* <Acordion index={index} /> */}
          <div
            className={`pb-2 mb-2  d-flex flex-wrap flex-row-reverse ${styles.LogInContainer}`}
            // style={{ maxHeight: "100vh" }}
          >
            <div
              className={`col-lg-4 col-12 col-sm-8 mx-auto px-3   `}
              style={{ marginTop: 100 }}
            >
              <div
                className={` ms-1 d-flex flex-column justify-content-between ${styles.positionFixed}`}
                style={{
                  // backgroundColor: "rgb(254 250 247)",
                  borderRadius: "20px",
                  boxShadow: "-3px 3px 8px rgb(0 0 0 / 16%)"
                }}
              >
                <div>
                  {/* <div class="btn "> جمع کالا ها{addCommas(prices.product)}</div>
              <div class="btn ">
                {addCommas(prices.basket)}
                جمع سبد ها
              </div> */}
                  <h5
                    className="border-bottom py-3  text-light text-center"
                    style={{
                      backgroundColor: "#f04937",
                      borderTopLeftRadius: "20px",
                      borderTopRightRadius: "20px"
                    }}
                  >
                    فاکتور خرید
                  </h5>
                  <div className="d-flex flex-wrap">
                    <div className=" d-flex flex-wrap  col-12">
                      <h6 className="ps-3 col-12 col-sm-6"> مجموع سبد خرید:</h6>
                      <p className="pe-3 text-end col-12 col-sm-6">
                        {addCommas(prices.total + prices.discount)}تومان
                      </p>
                    </div>
                    <div className="d-flex flex-wrap col-12">
                      <h6 className="ps-3 col-12 col-sm-6">مجموع تخفیف:</h6>
                      <p className="pe-3 text-end col-12 col-sm-6 text-danger">
                        {addCommas(prices.discount)}تومان
                      </p>
                    </div>
                    <div className="d-flex flex-wrap col-12">
                      <h6 className="ps-3 col-12 col-sm-6">هزینه ارسال:</h6>
                      <p className="pe-3 text-end col-12 col-sm-6 text-danger">
                        {addCommas(sumDeliveryPrice())}تومان
                      </p>
                    </div>
                    <div className="px-3">
                      <label>از</label>
                      <label className="px-1">{datas.length}</label>
                      <span>{"فروشگاه"} </span>
                      {datas.length > 0 &&
                        datas.map((value, index) => {
                          return (
                            <span>
                              <label className="px-1 text-danger">
                                {value.supplier.title}
                              </label>
                              {index != datas.length - 1 && <label>,</label>}
                            </span>
                          );
                        })}
                      <span>در حال خرید هستید.</span>
                    </div>

                    <div
                      className=" w-100 mx-3 mt-1 mb-2"
                      style={{ border: "1px solid lightgray" }}
                    ></div>
                    {/* <div className="m-3">
                      <h6>شیوه ارسال:</h6>
                      <div className="ps-2 mt-1">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault1"
                            onChange={(e) => {
                              setSend("fast");
                            }}
                          />
                          <label
                            className="form-check-label "
                            htmlFor="flexRadioDefault1"
                          >
                            ارسال سریع
                          </label>
                          <p style={{ fontSize: "13px" }}>
                            {supplierCount == 0
                              ? "بازای خرید از هر فروشگاه زمان ارسال 30 دقیقه و هزینه ارسال 10,000 تومان می باشد."
                              : `مدت زمان ارسال ${
                                  supplierCount * 30
                                }  دقیقه و هزینه ارسال ${addCommas(
                                  supplierCount * 10000
                                )} تومان می باشد.`}
                          </p>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault2"
                            defaultChecked
                            onChange={(e) => {
                              setSend("normal");
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault2"
                          >
                            ارسال عادی
                          </label>
                          <p style={{ fontSize: "13px" }}>
                            {supplierCount == 0
                              ? "بازای خرید از هر فروشگاه زمان ارسال 60 دقیقه و هزینه ارسال 8,000 تومان می باشد."
                              : `مدت زمان ارسال حداکثر ${
                                  supplierCount * 60
                                }  دقیقه و هزینه ارسال ${addCommas(
                                  supplierCount * 8000
                                )} تومان می باشد.`}
                          </p>
                        </div>
                      </div>
                    </div> */}
                    <div className=" d-flex flex-wrap  col-12">
                      <h6 className="ps-3 col-12 col-sm-6">
                        {" "}
                        مبلغ قابل پرداخت:
                      </h6>
                      <p className="pe-3 text-end col-12 col-sm-6 text-danger">
                        {addCommas(prices.total + sumDeliveryPrice())}تومان
                      </p>
                    </div>
                  </div>
                </div>
                <div className={`text-center mt-2 mb-5`}>
                  <button
                    type="button"
                    className={`w-50  btn text-light  ${styles.continueHover}`}
                    onClick={add}
                    disabled={disableButton}
                    style={{ backgroundColor: "#f04937" }}
                  >
                    {" "}
                    ادامه خرید
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-12 mt-5">
              <div className="me-2">
                {datas.length > 0 ? (
                  datas.map((value, index) => {
                    return (
                      <>
                        <div className="mt-3">
                          <div className="d-flex align-items-center justify-content-start mt-1 ">
                            {/* <img
                          style={{
                            width: 40,
                            height: 40,
                          }}
                          className="rounded-pill mx-2"
                          src={`http://sabadi.tatdemo.ir/${value.supplier.path}`}
                        /> */}
                            <div
                              className={`text-light px-3 ms-5 ${styles.title}`}
                              style={{
                                backgroundColor: "#673CFC",
                                borderTopLeftRadius: 10,
                                borderTopRightRadius: 10,
                                paddingTop: 4,
                                paddingBottom: 3
                              }}
                            >
                              {value.supplier.title}
                            </div>
                          </div>
                          <div
                            className=" "
                            style={{
                              borderRadius: "30px",
                              boxShadow: " -3px 3px 8px rgb(0 0 0 / 16%)"
                            }}
                          >
                            <div className="d-flex justify-content-center">
                              <p
                                style={{
                                  fontSize: "13px",
                                  display:
                                    !limitId.includes(
                                      value.supplier.suppliers__id
                                    ) && "none"
                                }}
                                className="text-light bg-danger text-center py-1 px-2 rounded rounded-5"
                              >
                                حداقل سفارش این فروشگاه &nbsp;
                                {addCommas(value.supplier.min_order_amount)}
                                &nbsp; تومان می باشد.
                              </p>
                            </div>
                            <div
                              className="accordion accordion-flush "
                              id="accordionFlushExample"
                            >
                              <div className="accordion-item">
                                <h2
                                  className="accordion-header"
                                  id={`flush-${value.supplier.suppliers__id}-${index}`}
                                >
                                  <div className="shadow">
                                    <div
                                      className=" pt-2 ps-3 mx-4 d-flex flex-wrap"
                                      style={{
                                        borderBottomLeftRadius: 10,
                                        borderBottomRightRadius: 10,
                                        paddingBottom: 1,
                                        color: "navy",
                                        border: "1px solid rgb(222 213 249)"
                                      }}
                                    >
                                      <div className="col-12 col-xl-2 fs-6">
                                        شیوه ارسال:
                                      </div>

                                      <div className="form-check col-12 col-md-6 col-xl-5 my-1">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name={`flexRadioDefault-${value.supplier.suppliers__id}`}
                                          id={`flexRadioDefault1-fast-${value.supplier.suppliers__id}-${index}`}
                                          // checked={
                                          //   datas[index].delivery.fast.status ==
                                          //   true
                                          // }
                                          // defaultChecked
                                          onChange={e => {
                                            deliveryHandler(index, "fast");
                                            console.log(
                                              "datas[index].delivery.fast",
                                              datas[index].delivery.fast
                                            );
                                            setSend("fast");
                                          }}
                                        />
                                        <label
                                          className="form-check-label "
                                          htmlFor={`flexRadioDefault1-fast-${value.supplier.suppliers__id}-${index}`}
                                        >
                                          ارسال سریع -{" "}
                                          {deliveryPrice(
                                            value.delivery?.fast.price,
                                            value.delivery?.fast.discount
                                          )}{" "}
                                          -{" "}
                                          {convertSecToMinOrH(
                                            value.delivery?.fast.time
                                          )}
                                        </label>
                                        {/* <p style={{ fontSize: "13px" }}>
                                  {supplierCount == 0
                                    ? "بازای خرید از هر فروشگاه زمان ارسال 30 دقیقه و هزینه ارسال 10,000 تومان می باشد."
                                    : `مدت زمان ارسال ${
                                        supplierCount * 30
                                      }  دقیقه و هزینه ارسال ${addCommas(
                                        supplierCount * 10000
                                      )} تومان می باشد.`}
                                </p> */}
                                      </div>
                                      <div className="form-check col-12 col-md-6 col-xl-5 my-1">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name={`flexRadioDefault-${value.supplier.suppliers__id}`}
                                          id={`flexRadioDefault2-normal-${value.supplier.suppliers__id}-${index}`}
                                          // checked={
                                          //   datas[index].delivery.normal
                                          //     .status == true
                                          // }
                                          onChange={e => {
                                            deliveryHandler(index, "normal");
                                            console.log(
                                              "datas[index].delivery.normal",
                                              datas[index].delivery.normal
                                            );

                                            // console.log("llll", value, index);
                                            setSend("normal");
                                          }}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={`flexRadioDefault2-normal-${value.supplier.suppliers__id}-${index}`}
                                        >
                                          ارسال عادی -{" "}
                                          {deliveryPrice(
                                            value.delivery?.normal.price,
                                            value.delivery?.normal.discount
                                          )}
                                          -{" "}
                                          {convertSecToMinOrH(
                                            value.delivery?.normal.time
                                          )}{" "}
                                        </label>
                                        {/* <p style={{ fontSize: "13px" }}>
                                  {supplierCount == 0
                                    ? "بازای خرید از هر فروشگاه زمان ارسال 60 دقیقه و هزینه ارسال 8,000 تومان می باشد."
                                    : `مدت زمان ارسال حداکثر ${
                                        supplierCount * 60
                                      }  دقیقه و هزینه ارسال ${addCommas(
                                        supplierCount * 8000
                                      )} تومان می باشد.`}
                                </p> */}
                                      </div>
                                    </div>
                                    <div
                                      className=" pt-2 ps-3 mx-4 "
                                      style={{
                                        borderBottomLeftRadius: 10,
                                        borderBottomRightRadius: 10,
                                        paddingBottom: 1,
                                        color: "navy",
                                        marginBottom: "10px"
                                        // border: "1px solid rgb(222 213 249)"
                                      }}
                                    >
                                      <div className="fs-6 fw-bolder">
                                        اقلام :
                                      </div>
                                      <div
                                        className="mt-2"
                                        style={{
                                          fontSize: 14,
                                          lineHeight: "1"
                                        }}
                                      >
                                        {// console.log("xxx", value.items)
                                        value.items.map((v, i) => {
                                          return (
                                            <label>
                                              <span>{v.product_title}</span>
                                              {i != value.items.length - 1 && (
                                                <span>{"-"}</span>
                                              )}
                                            </label>
                                          );
                                        })}
                                      </div>
                                    </div>
                                    {/* </div> */}
                                    <button
                                      className={`accordion-button collapsed ${styles.btnCart}`}
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target={`#accordion-${value.supplier.suppliers__id}-${index}`}
                                      aria-expanded="false"
                                      aria-controls={`accordion-${value.supplier.suppliers__id}-${index}`}
                                    ></button>
                                  </div>
                                  {/* </button> */}
                                </h2>
                                <div
                                  // id="flush-collapseOne"
                                  id={`accordion-${value.supplier.suppliers__id}-${index}`}
                                  className="accordion-collapse collapse"
                                  // aria-labelledby="flush-headingOne"
                                  aria-labelledby={`flush-${value.supplier.suppliers__id}-${index}`}
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <div className="d-flex w-100 mt-3">
                                      <label>توضیحات:</label>
                                      <textarea
                                        className="form-control ms-2 me-4 mb-2"
                                        onChange={e => {
                                          inputHandler(
                                            "description",
                                            e.target.value,
                                            index
                                          );
                                        }}
                                      />
                                    </div>
                                    {value.items.map((valueItems, index2) => {
                                      return valueItems.rto_basket_id == "0" ? (
                                        // ? console.log("zero")
                                        <ShoppingCart
                                          data={valueItems}
                                          updateShoppingList={
                                            updateShoppingList
                                          }
                                          index={index2}
                                          length={value.items.length}
                                          setIsLoading={setIsLoading}
                                        />
                                      ) : (
                                        <Acordion
                                          data={valueItems}
                                          updateShoppingList={
                                            updateShoppingList
                                          }
                                          index={index2}
                                          length={value.items.length}
                                          setIsLoading={setIsLoading}
                                        />
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })
                ) : (
                  <h3 className="mt-5 pt-4 text-center">
                    در حال حاضر سبد خرید شما خالی است!
                  </h3>
                )}
                {/* {shoppingData.length > 0 &&
                  shoppingData.map(
                    (value, index) => {
                      return value.rto_basket_id == "0" ? (
                        // ? console.log("zero")
                        <ShoppingCart
                          data={value}
                          updateShoppingList={updateShoppingList}
                        />
                      ) : (
                        <Acordion
                          data={value}
                          updateShoppingList={updateShoppingList}
                          index={index}
                        />
                      );
                    }
                    // console.log("not zero")
                  )} */}
              </div>
            </div>
          </div>

          {/* <button
                onClick={SendNumber}
                  style={{
                    height: "50px",
                    borderRadius: "15px",
                    backgroundColor: "#1A3764",
                    color: "white",
                  }}
                  className="btn  mb-3 w-75"
                >
                  ادامه
                </button> */}

          {/* <div class="modal-footer px-5 w-100 d-flex justify-content-between">
            <div>
              <div class="btn "> جمع کالا ها{addCommas(prices.product)}</div>
              <div class="btn ">
                {addCommas(prices.basket)}
                جمع سبد ها
              </div>
              <div class="btn ">جمع قیمت سبد خرید{addCommas(prices.total)}</div>
              <div class="btn ">
                سود شما از این خرید {addCommas(prices.discount)}
              </div>
            </div>
            <button
              type="button"
              class="btn btn-danger"
              onClick={add}
              disabled={disableButton}
            >
              {" "}
              ادامه
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
}
